module.exports = "<footer :class=currentPath _v-3a9b89d8=\"\"><div class=\"container text-center\" _v-3a9b89d8=\"\"><p _v-3a9b89d8=\"\">{{'FOOTER_COPYRIGHT' | wordDict}} |<a href=/disclaimer _v-3a9b89d8=\"\">{{'MENU_DISCLAIMER' | wordDict}}</a></p></div></footer>";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-3a9b89d8!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./assets/component/base/footer.vue
// module id = 367
// module chunks = 0